import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { QuestionDemo } from '@/components/demo/QuestionDemo';
import { WaitlistForm } from '@/components/forms/WaitlistForm';

const CAPABILITIES = [
  'Ver simultáneamente NAP nacional y diseño de tu provincia.',
  'Identificar dónde tu jurisdicción amplía o desarrolla un NAP.',
  'Anclar tu secuencia con citas textuales a la norma.',
  'Detectar alineaciones entre objetivos institucionales y norma vigente.',
];

export function Docentes() {
  return (
    <>
      <section className="rule-bottom">
        <Container className="pt-16 pb-16 md:pt-24 md:pb-20">
          <Eyebrow className="mb-8">Para docentes</Eyebrow>
          <h1 className="max-w-5xl font-display text-5xl font-medium leading-[1.05] tracking-tight text-accent md:text-6xl lg:text-7xl">
            Tu planificación, anclada
            <br />
            <span className="font-normal italic">al NAP y a tu jurisdicción.</span>
          </h1>
          <p className="mt-8 max-w-prose text-lg leading-relaxed text-ink-muted md:text-xl">
            Sin saltar entre cinco PDFs. Sin inventar relaciones. Con cita.
          </p>
        </Container>
      </section>

      <Section className="pt-0">
        <Container width="editorial">
          <ul className="flex flex-col">
            {CAPABILITIES.map((c) => (
              <li
                key={c}
                className="border-t border-line py-5 font-serif text-lg leading-snug text-ink first:border-t-0"
              >
                {c}
              </li>
            ))}
          </ul>
        </Container>
      </Section>

      <Section ariaLabelledby="demo-docentes-title" className="bg-paper-tinted/40">
        <Container>
          <h2 id="demo-docentes-title" className="mb-8 max-w-editorial font-serif text-3xl font-normal tracking-tight">
            Probalo con preguntas de planificación.
          </h2>
          <QuestionDemo />
        </Container>
      </Section>

      <Section ariaLabelledby="cuando-title">
        <Container width="editorial">
          <Eyebrow>Cuándo llega</Eyebrow>
          <h2 id="cuando-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            El acceso individual depende del avance institucional.
          </h2>
          <p className="prose-editorial mt-6">
            Cubrimos jurisdicciones progresivamente. La curaduría humana es lenta a propósito: cada
            diseño jurisdiccional valida con un especialista antes de habilitarse para consulta.
            Te avisamos cuando tu jurisdicción esté disponible.
          </p>
        </Container>
      </Section>

      <Section ariaLabelledby="waitlist-title" className="border-t border-line">
        <Container width="editorial">
          <Eyebrow>Lista de espera</Eyebrow>
          <h2 id="waitlist-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Anotate. Te escribimos cuando puedas usar SICA.
          </h2>
          <WaitlistForm audience="docentes" className="mt-8" />
        </Container>
      </Section>
    </>
  );
}
